import styled, { keyframes } from "styled-components";
import { Card } from "antd";

const Container = styled.div`
  padding: 3px;
  overflow-y: scroll;
`;

const GraphContainer = styled.div``;

const LineCard = styled(Card)`
  height: 67vh;
  border-radius: 15px;
`;

const SpinArea = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RankingCard = styled(Card)`
  height: 50vh;
  margin-left: 20px;
  border-radius: 15px;
`;

const HeaderKeyFrame = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`;

const Gradient = styled(Card)`
  background: linear-gradient(to top right, #1690ff, #2ebfa5, #3083dc);
  animation: ${HeaderKeyFrame} 8s ease infinite;
  background-size: 200% 100%;
  padding: 10px;
  margin-left: 20px;
  margin-top: 20px;
  height: 28vh;
`;

const InformationCard = styled.div`
  span {
    color: #8c8c8c;
    font-weight: 600;
  }
  h5 {
    margin: 0px 0px 15px !important;
    font-size: 20px;
  }
`;
const WhiteParagraph = styled.p`
  margin-top: 5px;
  color: white;
  font-weight: 600;
  font-size: 17px;
`;

const LinkRight = styled.a`
  color: #1890ff;
  display: block;
  cursor: pointer;
  font-weight: 600;

  .anticon-right {
    color: #40a9ff;
    margin-left: 2px;
  }
`;

const InformationFooter = styled.div`
  margin-top: 5px;
`;

const cardStyle = {
  borderRadius: 12,
  boxShadow: '0 3px 6px rgba(0, 0, 0, 0.05)',
};

export {
  Container,
  GraphContainer,
  LineCard,
  SpinArea,
  RankingCard,
  Gradient,
  InformationCard,
  WhiteParagraph,
  LinkRight,
  InformationFooter,
  cardStyle,
}
